import isAcmeOrganization from '@/lib/utils/isAcmeOrganization'
import isDemoOrganization from '@/lib/utils/isDemoOrganization'
import type { IOrganization } from '@/types/organization'

// Demo orgs have no real integrations behind them, so they are served ACME's in-code sample data
export const shouldUseAcmeMockData = (organization: IOrganization): boolean =>
  isAcmeOrganization(organization) || isDemoOrganization(organization)
